module.exports = __webpack_public_path__ + "static/media/IconLearningOutcomes.77b5e0ae.png";